module.exports = __webpack_public_path__ + "static/media/peter8.2b99f17c.jpg";